const FEATURE_FLAGS = {
  mya: {
    changeDelivery: 'myaccount.sales.enableChangeDeliveryMethod',
    /** Is Favorites page active in speedy? */
    favorites: 'myaccount.favorites.enable',
    /** Is Profile page active in speedy? */
    profile: 'myaccount.profile.enable',
    /** Is ProListing Bulk Actions active? */
    proUser: 'myaccount.proUser.enabled',
    /** Is ProListing Bulk Actions active? */
    proUserIs: 'myaccount.proUser.is',
    /** Sales active in speedy? */
    sales: 'myaccount.sales.enable',
    /** Orders active in speedy? */
    orders: 'myaccount.orders.enable',
    /** Old orders cards active */
    newOrdersCards: 'myaccount.orders.newCards',
    /** Payments active in speedy? */
    payments: 'myaccount.payments.enable',
    /** Chatbot enabled */
    chatbot: 'myaccount.chatbot.enable',
    /** VoiceFlow Chatbot enabled */
    voiceFlow: 'myaccount.voiceflow.enable',
    /** New Relist Enabled */
    newRelist: 'myaccount.relist.enabled',
    /** Add new listing feature */
    proListingsAddNewListing: 'myaccount.proListings.addNewListing.enabled',
    menu: {
      /** Hide Favorites link from the menu? */
      hideFavorites: 'myaccount.menu.favorites.hide',
    },
    RQDevTools: 'myaccount.RQ.devTools.enabled',
  },
  common: {
    editListings: {
      /** shows missing option in traits modal */
      missingOption: 'common.traits.modal.missingOption',
    },
    promocode: 'common.promocode.show',
    giftCodeNotApplicable: 'common.giftCode.notApplicable',
    listing: {
      EUBankAccountEnabled: 'common.EUBankAccountBannerEnabled',
    },
  },
  payments: {
    /** whether filtering allowed in /my/payments or not */
    filter: 'myaccount.payments.filter.enable',
    /** Show the message to be considered as a business seller  */
    showPrivateSellerOption: 'myaccount.showPrivateSellerOption',
  },
  submenus: {
    paymentSellerConfig: 'myaccount.payments.sellerConfig.enable',
    paymentBuyerConfig: 'myaccount.payments.buyerConfig.enable',
  },
  settings: {
    showDSA: 'myaccount.settings.showDSA',
  }
};

export default FEATURE_FLAGS;
